import React, { useState } from "react";
import { toast } from "react-hot-toast";
import Select from "react-select";
import { fileToBase64 } from "../../utils/helpers/logicHelper";
import {
  customerTypeDropdown,
  documentType,
} from "../../utils/helpers/objectHelpers";
import { corporateBoardMember } from "../../utils/services/users.services";
import CustomDatePicker from "../datePickers/CustomDatePicker";
import Continue from "./Continue";

function CorporateRepInfo({
  dictionary,
  countries,
  associatedRuleId,
  handleClose,
  customerId,
  title,
  actionType,
  userId,
}) {
  const languageStatus = !(
    typeof dictionary === "undefined" || dictionary === null
  );
  // eslint-disable-next-line no-unused-vars
  const documents = documentType(languageStatus, dictionary);
  const [loading, setLoading] = useState(false);
  const [isPolitical, setIsPolitical] = useState(false);
  const [actAccodanceToPowerOfAttorny, setActAccodanceToPowerOfAttorny] =
    useState(false);
  const [userType, setUserType] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [formData, setFormData] = useState([
    {
      firstName: "",
      lastName: "",
      dateOfBirth: "",
      email: "",
      address1: "",
      city: "",
      postcode: "",
      state: "",
      countryIso3: "",
      cooperateShareHolderCompanyRegNo: "",
      representivType: "",
      positionHeld: "",
      shareSize: 0,
      associatedRuleId: associatedRuleId,
      cooperateShareHolderCompanyRegDate: "",
      cooperateShareHolderCompanyName: "",
      isPolitical: true,
      file_base64: "",
      name: "",
      idType: "",
      dob: "",
      issueCountry: "",
      issueNo: "",
      issueDate: "",
      expiryDate: "",
      tin: "",
      politicalExposedDetails: "",
      cetizenship: "",
      actAccodanceToPowerOfAttorny: "",
    },
  ]);
  const addFields = () => {
    let obj = {
      firstName: "",
      lastName: "",
      dateOfBirth: "",
      email: "",
      address1: "",
      city: "",
      postcode: "",
      state: "",
      countryIso3: "",
      cooperateShareHolderCompanyRegNo: "",
      representivType: "",
      positionHeld: "",
      shareSize: 0,
      associatedRuleId: associatedRuleId,
      cooperateShareHolderCompanyRegDate: "",
      cooperateShareHolderCompanyName: "",
      isPolitical: false,
      file_base64: "",
      name: "",
      idType: "",
      dob: "",
      issueCountry: "",
      issueNo: "",
      issueDate: "",
      expiryDate: "",
      tin: "",
      cetizenship: "",
      politicalExposedDetails: "",
      actAccodanceToPowerOfAttorny: "",
      // associatedRuleId: associatedRuleId,
    };
    setFormData([...formData, obj]);
  };

  const repTypes = [
    { label: "DIRECTOR", value: "DIRECTOR" },
    { label: "REPRESENTATIVE", vale: "REPRESENTATIVE" },
    {
      label: "ULTIMATE BENEFICIAL",
      vale: "ULTIMATE_BENEFICIAL",
    },
    {
      label: "INDIVIDUAL SHARE HOLDER",
      value: "INDIVIDUAL_SHARE_HOLDER",
    },
    {
      label: "COOPERATE SHARE HOLDER",
      value: "COOPERATE_SHARE_HOLDER",
    },
  ];

  const removeFields = (index) => {
    if (index > 0) {
      let data = [...formData];
      data.splice(index, 1);
      setFormData(data);
    }
  };

  const handleFormChange = (e, index) => {
    let data = [...formData];
    data[index][e.target.name] = e.target.value || e.target.checked;
    setFormData(data);
    if (
      userType.value === "INDIVIDUAL" &&
      data[index].firstName !== "" &&
      data[index].lastName !== "" &&
      data[index].dateOfBirth !== "" &&
      data[index].cetizenship !== ""
    ) {
      setDisabled(false);
    }

    if (
      data[index].cooperateShareHolderCompanyRegDate !== "" &&
      data[index].cooperateShareHolderCompanyName !== "" &&
      data[index].cooperateShareHolderCompanyRegNo !== "" &&
      data[index].positionHeld !== "" &&
      data[index].issueCountry !== "" &&
      data[index].countryIso3 !== "" &&
      data[index].city !== "" &&
      data[index].address1 !== "" &&
      data[index].representivType !== "" &&
      data[index].tin !== "" &&
      data[index].file_base64 !== "" &&
      data[index].issueNo !== "" &&
      data[index].issueCountry !== ""
    ) {
      setDisabled(false);
    }
  };

  const onChangeFile = async (event) => {
    const allowedExtensions = [
      "jpg",
      "jpeg",
      "png",
      "pdf",
      "doc",
      "docx",
      "JPG",
      "JPEG",
      "PNG",
      "PDF",
      "DOC",
      "DOCX",
    ];
    const sizeLimit = 2097152;
    const selectedFileSize = event.target.files[0].size || "";
    const selectedFileName = event.target.files[0].name || null;
    const fileExtension = selectedFileName.split(".").pop();
    if (typeof selectedFileSize === "undefined") return false;
    else if (
      event.target.files[0] &&
      !allowedExtensions.includes(fileExtension)
    )
      toast.error("File must be an image or document");
    else if (selectedFileSize > sizeLimit) toast.error("File size too large");
    else await event.target.files[0];
  };

  const onSubmit = async (data) => {
    setLoading(true);
    const payload = data.map((data) => {
      let attachedDocument = {
        file_base64: data.file_base64,
        idType: actionType,
        issueCountry: data.issueCountry,
        issueNo: data.issueNo,
      };
      if (data?.issueDate) {
        attachedDocument = {
          ...attachedDocument,
          issueDate:
            data?.issueDate !== undefined ? data?.issueDate.toISOString() : "",
        };
      }
      if (data?.expiryDate) {
        attachedDocument = {
          ...attachedDocument,
          expiryDate:
            data?.expiryDate !== undefined
              ? data?.expiryDate.toISOString()
              : "",
        };
      }

      let objPayload = {
        firstName: data?.firstName,
        lastName: data?.lastName,
        email: data?.email,
        addressEntityDTO: {
          address1: data?.address1,
          address2: data?.address1,
          city: data?.city,
          countryCommonName: data?.countryIso3,
          postcode: data?.postcode,
          province: data?.city,
          countryIso3: data?.countryIso3,
          state: data?.state,
        },
        positionHeld: data?.positionHeld,
        shareSize: parseInt(data?.shareSize),
        associatedRuleId: data?.associatedRuleId,
        representivType: data?.representivType,
        cooperateShareHolderCompanyRegNo:
          data?.cooperateShareHolderCompanyRegNo,
        cooperateShareHolderCompanyName: data?.cooperateShareHolderCompanyName,
        isPolitical: isPolitical,
        attachedDocument: [attachedDocument],
        tin: data?.tin,
        politicalExposedDetails: data.politicalExposedDetails,
        cetizenship: data.cetizenship,
        actAccodanceToPowerOfAttorny: actAccodanceToPowerOfAttorny,
      };

      if (userType.value === "INDIVIDUAL" && data?.dateOfBirth) {
        objPayload = {
          ...objPayload,
          dateOfBirth:
            data?.dateOfBirth !== undefined
              ? data?.dateOfBirth.toISOString()
              : "",
        };
      }

      if (data?.cooperateShareHolderCompanyRegDate) {
        objPayload = {
          ...objPayload,
          cooperateShareHolderCompanyRegDate:
            data?.cooperateShareHolderCompanyRegDate !== undefined
              ? data?.cooperateShareHolderCompanyRegDate.toISOString()
              : "",
        };
      }
      return {
        ...objPayload,
      };
    });

    const memberPayload = { roles: payload };
    try {
      const response = await corporateBoardMember(memberPayload);
      if (response.status === 200) {
        setLoading(false);
        handleClose();
        toast.success(response.data.message);
        setFormData([
          {
            firstName: "",
            lastName: "",
            dateOfBirth: "",
            email: "",
            address1: "",
            city: "",
            postcode: "",
            state: "",
            countryIso3: "",
            cooperateShareHolderCompanyRegNo: "",
            representivType: "",
            positionHeld: "",
            shareSize: 0,
            associatedRuleId: associatedRuleId,
            cooperateShareHolderCompanyRegDate: "",
            cooperateShareHolderCompanyName: "",
            isPolitical: true,
            file_base64: "",
            name: "",
            idType: "",
            dob: "",
            issueCountry: "",
            issueNo: "",
            issueDate: "",
            expiryDate: "",
          },
        ]);
        setUserType("");
      }
    } catch (error) {
      setLoading(false);
    }
    setLoading(false);
  };

  const text =
    actionType === "COOPERATE_SHARE_HOLDER"
      ? "Shareholder"
      : actionType === "DIRECTORS_PASSPORT"
      ? "Director"
      : "";

  const customerTypesDropdown = customerTypeDropdown(
    languageStatus,
    dictionary
  );

  return (
    <form
      className="needs-validation pt-1 ms-5 ps-5"
      onSubmit={(e) => e.preventDefault()}
    >
      {/* COMPANY REPRESENTATIVE */}
      <h5 className="title">{title}</h5>
      <div className="row">
        {title !==
          "Passport or other identification documents of directors" && (
          <div className="row">
            <div
              className="col-xl-12 col-lg-12 col-md-12 mb-3"
              id="customer-type"
            >
              <Select
                options={customerTypesDropdown}
                isClearable={false}
                isSearchable={true}
                maxMenuHeight={250}
                menuPlacement="bottom"
                name="type"
                value={userType}
                onChange={(option) => {
                  setUserType(option);
                }}
                placeholder={
                  languageStatus ? dictionary["l_customer_type"] : "Type"
                }
              />
            </div>
          </div>
        )}
        {formData.map((i, index) => {
          return (
            <>
              {userType.value === "INDIVIDUAL" && (
                <div className="row">
                  <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                    <input
                      type="text"
                      name="firstName"
                      id="firstName"
                      className={`form-control name-fields ps-3`}
                      onChange={(e) => {
                        handleFormChange(e, index);
                      }}
                      placeholder={
                        dictionary
                          ? dictionary["para_first_name"]
                          : "First Name"
                      }
                      required
                    />
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                    <input
                      type="text"
                      name="lastName"
                      id="lastName"
                      className={`form-control name-fields ps-3`}
                      onChange={(e) => {
                        handleFormChange(e, index);
                      }}
                      placeholder={
                        dictionary
                          ? dictionary["WO_LAST_NAM_-1125905146"]
                          : "Last Name"
                      }
                      required
                    />
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                    <Select
                      options={countries}
                      isClearable={false}
                      isSearchable={true}
                      maxMenuHeight={250}
                      menuPlacement="bottom"
                      name="cetizenship"
                      onChange={(option) => {
                        const e = {
                          target: {
                            value: option.iso3Code,
                            name: "cetizenship",
                          },
                        };
                        handleFormChange(e, index);
                      }}
                      placeholder={"Citizenship"}
                    />
                  </div>
                </div>
              )}

              <div className="row">
                {userType.value === "INDIVIDUAL" && (
                  <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                    <CustomDatePicker
                      getDate={(value) => {
                        const e = {
                          target: { value: value, name: "dateOfBirth" },
                        };
                        handleFormChange(e, index);
                      }}
                      showYearDropdown
                      selectDropdownMode
                      // withPortal
                      // setMaxDate={new Date()}
                      placeholderText={`Date of Birth`}
                    />
                  </div>
                )}
                <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                  <input
                    type="text"
                    name="phoneNumber"
                    id="phoneNumber"
                    className={`form-control name-fields ps-3`}
                    onChange={(e) => {
                      handleFormChange(e, index);
                    }}
                    placeholder={
                      dictionary ? dictionary["l_phone_number"] : "Phone number"
                    }
                    required
                  />
                </div>
                <div className={`col-xl-4 col-lg-4 col-md-4 mb-3`}>
                  <input
                    type="text"
                    name="email"
                    id="email"
                    className={`form-control name-fields ps-3`}
                    onChange={(e) => {
                      handleFormChange(e, index);
                    }}
                    placeholder={
                      dictionary ? dictionary["WO_EMAI_1903518907"] : "Email"
                    }
                    required
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                  <input
                    type="text"
                    name="address1"
                    id="address1"
                    className={`form-control name-fields ps-3`}
                    onChange={(e) => {
                      handleFormChange(e, index);
                    }}
                    placeholder={
                      dictionary ? dictionary["l_address"] : "Address"
                    }
                    required
                  />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                  <input
                    type="text"
                    name="city"
                    id="city"
                    className={`form-control name-fields ps-3`}
                    onChange={(e) => {
                      handleFormChange(e, index);
                    }}
                    placeholder={"City"}
                    required
                  />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                  <input
                    type="text"
                    name="tin"
                    id="tin"
                    className={`form-control name-fields ps-3`}
                    onChange={(e) => {
                      handleFormChange(e, index);
                    }}
                    placeholder={"Tax Identification Number"}
                    required
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                  <input
                    type="text"
                    name="postcode"
                    id="postcode"
                    className={`form-control name-fields ps-3`}
                    onChange={(e) => {
                      handleFormChange(e, index);
                    }}
                    placeholder={
                      dictionary
                        ? dictionary["para_postcode"]
                        : "Area/Post code"
                    }
                  />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                  <input
                    type="text"
                    name="state"
                    id="state"
                    className={`form-control name-fields ps-3`}
                    onChange={(e) => {
                      handleFormChange(e, index);
                    }}
                    placeholder={
                      dictionary ? dictionary["WO_STAT_-878960465"] : "State"
                    }
                    required
                  />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                  <Select
                    options={countries}
                    isClearable={false}
                    isSearchable={true}
                    maxMenuHeight={250}
                    menuPlacement="bottom"
                    name="country"
                    onChange={(option) => {
                      const e = {
                        target: { value: option.iso3Code, name: "countryIso3" },
                      };
                      handleFormChange(e, index);
                    }}
                    placeholder={
                      dictionary
                        ? dictionary["WO_COUNTRY_1435082597"]
                        : "Country"
                    }
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                  <CustomDatePicker
                    getDate={(value) => {
                      const e = {
                        target: {
                          value: value,
                          name: "cooperateShareHolderCompanyRegDate",
                        },
                      };
                      handleFormChange(e, index);
                    }}
                    showYearDropdown
                    selectDropdownMode
                    // withPortal
                    // setMaxDate={new Date()}
                    placeholderText={`${text} Reg Date`}
                  />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                  <input
                    type="text"
                    name="cooperateShareHolderCompanyName"
                    id="cooperateShareHolderCompanyName"
                    className={`form-control name-fields ps-3`}
                    onChange={(e) => {
                      handleFormChange(e, index);
                    }}
                    placeholder={`${text} Company Name`}
                    required
                  />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                  <input
                    type="number"
                    name="shareSize"
                    id="shareSize"
                    className={`form-control name-fields ps-3`}
                    onChange={(e) => {
                      handleFormChange(e, index);
                    }}
                    placeholder={"Share Size"}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                  <input
                    type="text"
                    name="cooperateShareHolderCompanyRegNo"
                    id="cooperateShareHolderCompanyRegNo"
                    className={`form-control name-fields ps-3`}
                    onChange={(e) => {
                      handleFormChange(e, index);
                    }}
                    placeholder={`${text} Reg No`}
                    required
                  />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                  <input
                    type="text"
                    name="positionHeld"
                    id="positionHeld"
                    className={`form-control name-fields ps-3`}
                    onChange={(e) => {
                      handleFormChange(e, index);
                    }}
                    placeholder={`${text} position`}
                  />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                  <Select
                    options={repTypes}
                    isClearable={false}
                    isSearchable={true}
                    maxMenuHeight={250}
                    menuPlacement="bottom"
                    name="representivType"
                    onChange={(option) => {
                      const e = {
                        target: {
                          value: option.value,
                          name: "representivType",
                        },
                      };
                      handleFormChange(e, index);
                    }}
                    placeholder={`${text} Type`}
                  />
                </div>
              </div>

              <div className="row">
                <div className="row ps-5">
                  <div className="col-xl-8 col-lg-8 col-md-8 mb-3">
                    <input
                      type="checkbox"
                      id="actAccodanceToPowerOfAttorny"
                      name="actAccodanceToPowerOfAttorny"
                      className={`ps-3 me-2 check-box`}
                      onChange={(e) => {
                        handleFormChange(e, index);
                        setActAccodanceToPowerOfAttorny(e.target.checked);
                      }}
                    />
                    <span className="ps-2 subtitle align-bottom">
                      Acts in accordance with a power of attorney valid until
                      (specify)
                    </span>
                  </div>
                </div>
              </div>

              {/* Is the representative a politically exposed person? */}
              <div className="row">
                <div className="row ps-5">
                  <div className="col-xl-12 col-lg-12 col-md-12 mb-3 py-3">
                    <input
                      type="checkbox"
                      name="isPolitical"
                      id="isPolitical"
                      className={`ps-3 me-2 check-box`}
                      onChange={(e) => {
                        handleFormChange(e, index);
                        setIsPolitical(e.target.checked);
                      }}
                    />
                    <span className="ps-2 subtitle align-bottom">
                      {`Is the ${text} a politically exposed person or entity?`}
                    </span>
                  </div>
                </div>
                {isPolitical && (
                  <div className="col-xl-8 col-lg-8 col-md-8 mb-3">
                    <textarea
                      name="politicalExposedDetails"
                      id="politicalExposedDetails"
                      className="form-control text-area"
                      placeholder={"Enter Details"}
                      onChange={(e) => {
                        handleFormChange(e, index);
                      }}
                    />
                  </div>
                )}
              </div>

              <h5 className="title mt-4">{`${text} Document`}</h5>

              <div className="row">
                {/* IDENTITY UPLOAD */}

                <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                  <input
                    type="text"
                    name="issueNo"
                    id="issueNo"
                    className="form-control"
                    onChange={(e) => handleFormChange(e, index)}
                    placeholder={
                      dictionary ? dictionary["l_id_issue_no"] : "Issue Number"
                    }
                    required
                  />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                  <Select
                    options={countries}
                    isClearable={false}
                    isSearchable={true}
                    maxMenuHeight={250}
                    menuPlacement="bottom"
                    name="issueCountry"
                    onChange={(option) => {
                      const e = {
                        target: {
                          value: option.iso3Code,
                          name: "issueCountry",
                        },
                      };
                      handleFormChange(e, index);
                    }}
                    placeholder={
                      dictionary
                        ? dictionary["l_issue_country"]
                        : "Issue Country"
                    }
                  />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                  <CustomDatePicker
                    getDate={(value) => {
                      const e = {
                        target: { value: value, name: "issueDate" },
                      };
                      handleFormChange(e, index);
                    }}
                    showYearDropdown
                    selectDropdownMode
                    // withPortal
                    // setMaxDate={new Date()}
                    placeholderText={
                      dictionary ? dictionary["l_issue_date"] : "Issue Date"
                    }
                  />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                  <CustomDatePicker
                    getDate={(value) => {
                      const e = {
                        target: { value: value, name: "expiryDate" },
                      };
                      handleFormChange(e, index);
                    }}
                    showYearDropdown
                    selectDropdownMode
                    // withPortal
                    // setMaxDate={new Date()}
                    placeholderText={
                      dictionary ? dictionary["l_expiry_date"] : "Expiry Date"
                    }
                  />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                  <div className="input-group">
                    <input
                      onChange={async (event) => {
                        onChangeFile(event);
                        const file_base64 = await fileToBase64(
                          event.target.files[0]
                        );
                        const e = {
                          target: {
                            value: file_base64,
                            name: "file_base64",
                          },
                        };
                        handleFormChange(e, index);
                      }}
                      type="file"
                      className="form-control"
                      placeholder="Choose.."
                      readOnly
                    />
                  </div>
                </div>
              </div>

              <div className="row mt-4">
                <p className="subtitle">{`Is there any other ${text}?`}</p>
                <div className="row ps-5">
                  <div
                    className="col-xl-4 col-lg-4 col-md-4 mb-3 cols py-3"
                    onClick={() => {
                      addFields();
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    {/* <input
                      type="button"
                      
                      placeholder={"Full legal name"}
                      required
                    /> */}
                    <span className="ps-4 label">Yes</span>
                  </div>

                  <div
                    className="col-xl-4 col-lg-4 col-md-4 mb-3 cols ms-3 py-3"
                    onClick={() => {
                      removeFields(index);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    {/* <input
                      type="button"
                      
                      placeholder={"Full legal name"}
                      required
                    /> */}
                    <span className="ps-4 label">No</span>
                  </div>
                </div>
              </div>
            </>
          );
        })}

        <Continue
          dictionary={dictionary}
          onClick={() => {
            onSubmit(formData);
          }}
          loading={loading}
          disabled={disabled}
        />
      </div>
    </form>
  );
}

export default CorporateRepInfo;
